<template>
  <v-container class="navbar__container" fluid>
    <v-col offset-sm="1" sm="10">
      <v-row>
        <div class="navbar">
          <router-link class="navbar-item ml-0" v-for="(item, index) in navbarMenuList" :key="index" :to="item.path">
            {{item.name}}
          </router-link>
        </div>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: 'LayoutAdminBar',
  data () {
    return {
      navbarMenuList: [
        {name:'СОЗДАТЬ ЭКЗЕМПЛЯР', path:'/create/exhibit'},
        {name:'УПРАВЛЕНИЕ ИНДЕКСАМИ РОДА', path:'/manage/index-genus'},
        {name:'ДОБАВИТЬ ПУБЛИКАЦИЮ', path:'/create/article'},
        {name:'ДОБАВИТЬ НОВОСТЬ', path:'/create/new'},
        {name:'ДОБАВИТЬ ФОТО ВИДА', path:'/create/photo'},
        {name:'СОСТОЯНИЕ СЕРВЕРА', path:'/server-status'},
      ]
    }
  }

}
</script>

<style lang="scss" scoped>
@import "src/assets/styles/theme.scss";

.navbar__container {
  background-color: $color-blue-500;
}

.logo {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: 24px;
  padding: 5px 0;
  text-align: left;
}

.navbar {
  display: flex;
  flex-direction: row;
  font-size: $font-size-4;
  font-weight: 400;
  line-height: 24px;
  padding: 12px 0 12px 0;
  text-align: left;
  align-items: center;
  height: 100%;
}

.navbar-item {
  background-color: transparent;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  font-size: $font-size-4;
  font-style: normal;
  font-weight: 550;
  line-height: 20px;
  margin-left: 16px;
  margin-right: 16px;
  white-space: nowrap;
  position: relative;
  text-align: left;
  text-decoration-color: rgba(255, 255, 255, 0.7);
  text-decoration-line: none;
  text-decoration-style: solid;
  text-decoration-thickness: auto
}

.navbar-item::after {
  content: "";
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: $color-orange;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: .3s;
  transition: .3s;
}

.navbar-item:hover::after, .navbar-item.router-link-active::after  {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

a.router-link-active {
  color: $color-white;
}

@media (max-width: $breakpoint-xl) {
  .navbar {
    border: 0;
    margin: 0 auto;
  }

  .logo {
    width: 100%;
    margin: 0;
  }
  .logo img {
    margin: 0 auto;
  }
}

</style>